import { IError } from '@checkout/errors';
import { ICampaignSiteChangeSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic } from 'redux-observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { CampaignSiteChangeRequestAction, RootAction } from '../actions/actionTypes.d';
import ActionTypes from './../actions/actionTypes';
import { campaignSiteChangeSuccess, setErrors } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import { logger } from './../utils/logger';

export const campaignSiteChangeEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$
    .ofType(ActionTypes.CAMPAIGN_SITE_CHANGE_REQUEST)
    .mergeMap((action: CampaignSiteChangeRequestAction) => {
      return fromPromise$(rest.httpPut('/campaign-site', { uri: action.payload.uri }))
        .flatMap((response: AxiosResponse<ICampaignSiteChangeSuccessPayload>) => {
          return of$(campaignSiteChangeSuccess(response.data));
        })
        .catch((error: IError) => {
          logger(error);
          return of$(setErrors(error));
        });
    });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/campaign.ts